import React, { useEffect, useRef, useState } from "react";
import { PROVIDER_SIDEBAR_MENUS } from "../../constants/constants";
import { validatePropertyDescriptionForm } from "../../validators/providers/AddBusiness";
import { useFormContext } from "../../context/FormContext";
import api from "../../api/config";
import { toast } from "react-toastify";
import 'react-tooltip/dist/react-tooltip.css'; // Import tooltip CSS
import { Tooltip } from 'react-tooltip';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import FontAwesome CSS

const PropertyDescriptionForm = ({
  setActiveMenu,
  providerDetail,
  params,
  temp,
  setTemp,
  loading,
}) => {
  const { formData, setFormData } = useFormContext();
  console.log(formData, "formData");
  const [businessList, setBusinessList] = useState([]);
  const [descriptionFormData, setDescriptionFormData] = useState({
    price: formData?.propertyDetails?.price || "",
    rent: formData?.propertyDetails?.rent || "",
    totalSpace: formData?.propertyDetails?.totalSpace || "",
    availableSpace: formData?.propertyDetails?.availableSpace || "",
    minAvailableSpace: formData?.propertyDetails?.minAvailableSpace || "",
    businessType: formData?.propertyDetails?.businessType || "",
    subBusinessType: formData?.propertyDetails?.subBusinessType || "",
    remainingLeaseTerm: formData?.propertyDetails?.remainingLeaseTerm || "",
    minSubLeaseTerm: formData?.propertyDetails?.minSubLeaseTerm || "",
    layout: formData?.propertyDetails?.layout || "",
    parking: formData?.propertyDetails?.parking || "",
    description: formData?.propertyDetails?.description || "",
  });
  const refs = {
    price: useRef(null),
    rent: useRef(null),
    totalSpace: useRef(null),
    availableSpace: useRef(null),
    minAvailableSpace: useRef(null),
    businessType: useRef(null),
    subBusinessType: useRef(null),
    remainingLeaseTerm: useRef(null),
    minSubLeaseTerm: useRef(null),
    layout: useRef(null),
    parking: useRef(null),
    description: useRef(null),
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    price: "",
    rent: "",
    totalSpace: "",
    availableSpace: "",
    minAvailableSpace: "",
    businessType: "",
    subBusinessType: "",
    remainingLeaseTerm: "",
    minSubLeaseTerm: "",
    layout: "",
    parking: "",
    description: "",
  });

  const alphabetsAndSpacesRegex = /^[a-zA-Z\s]+$/;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (!!value && !alphabetsAndSpacesRegex.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only alphabets allowed.",
      }));

      return;
    } else {
      setDescriptionFormData({
        ...descriptionFormData,
        [name]: e.target.value,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Check for negative values
    if (Number(value) < 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Value cannot be negative",
      }));
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    setDescriptionFormData({
      ...descriptionFormData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (isSubmitting) {
      validateForm();
    }
  }, [descriptionFormData]);

  const validateleaseFields = () => {
    if (
      Number(descriptionFormData.minSubLeaseTerm) >
      Number(descriptionFormData.remainingLeaseTerm)
    ) {
      return "Cannot be greater than remaining lease term";
    }
    return "";
  };

  const validateOtherFields = () => {
    if (
      descriptionFormData.availableSpace !== "" &&
      descriptionFormData.minAvailableSpace !== ""
    ) {
      if (
        Number(descriptionFormData.minAvailableSpace) >
        Number(descriptionFormData.availableSpace)
      ) {
        return "Min available space cannot be greater than max available space";
      }
    }
    if (
      (descriptionFormData.minAvailableSpace !== "" ||
        descriptionFormData.availableSpace !== "") &&
      descriptionFormData.totalSpace !== ""
    ) {
      if (
        Number(descriptionFormData.minAvailableSpace) >
          Number(descriptionFormData.totalSpace) ||
        Number(descriptionFormData.availableSpace) >
          Number(descriptionFormData.totalSpace)
      ) {
        return "Cannot be greater than total space";
      }
    }
    if (descriptionFormData.availableSpace === "") {
      return "Max available space is required";
    }
    return "";
  };

  const validateForm = () => {
    const newErrors = {
      //price: validatePropertyDescriptionForm(
      //  descriptionFormData.price,
      //  "price"
      //),
      //rent: validatePropertyDescriptionForm(descriptionFormData.rent, "rent"),
      totalSpace: validatePropertyDescriptionForm(
        descriptionFormData.totalSpace,
        "totalSpace"
      ),
      //availableSpace: validatePropertyDescriptionForm(
      //  descriptionFormData.availableSpace,
      //  "availableSpace"
      //),
      //minAvailableSpace: validatePropertyDescriptionForm(
      //  descriptionFormData.minAvailableSpace,
      //  "minAvailableSpace"
      //),
      remainingLeaseTerm: validatePropertyDescriptionForm(
        descriptionFormData.remainingLeaseTerm,
        "remainingLeaseTerm"
      ),
      //minSubLeaseTerm: validatePropertyDescriptionForm(
      //  descriptionFormData.minSubLeaseTerm,
      //  "minSubLeaseTerm"
      //),
      businessType: validatePropertyDescriptionForm(
        descriptionFormData.businessType,
        "businessType"
      ),
      //subBusinessType: validatePropertyDescriptionForm(
      //  descriptionFormData.subBusinessType,
      //  "subBusinessType"
      //),
      //layout: validatePropertyDescriptionForm(
      //  descriptionFormData.layout,
      //  "layout"
      //),
      //parking: validatePropertyDescriptionForm(
      //  descriptionFormData.parking,
      //  "parking"
      //),
      description: validatePropertyDescriptionForm(
        descriptionFormData.description,
        "description"
      ),
    };

    //newErrors.minAvailableSpace = validateOtherFields();
    //newErrors.availableSpace = validateOtherFields();
    //newErrors.minAvailableSpace = validateOtherFields();
    //newErrors.minSubLeaseTerm = validateleaseFields();

    setErrors(newErrors);

    const firstErrorField = Object.keys(newErrors).find(
      (key) => newErrors[key]
    );
    if (firstErrorField) {
      refs[firstErrorField].current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }

    return Object.values(newErrors).every((error) => error === "");
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    const isFormValid = validateForm();
    if (isFormValid) {
      setIsSubmitting(false);
      setFormData(prev => ({
        ...prev,
        propertyDetails: {
          //price: descriptionFormData.price,
          rent: descriptionFormData.rent,
          totalSpace: descriptionFormData.totalSpace,
          //availableSpace: descriptionFormData.availableSpace,
          //minAvailableSpace: descriptionFormData.minAvailableSpace,
          remainingLeaseTerm: descriptionFormData.remainingLeaseTerm,
          //minSubLeaseTerm: descriptionFormData.minSubLeaseTerm,
          businessType: descriptionFormData.businessType,
          //subBusinessType: descriptionFormData.subBusinessType,
          //layout: descriptionFormData.layout,
          //parking: descriptionFormData.parking,
          description: descriptionFormData.description,
        }
      }));
      /*
      setFormData({
        ...formData,
        propertyDetails: {
          price: descriptionFormData.price,
          rent: descriptionFormData.rent,
          totalSpace: descriptionFormData.totalSpace,
          availableSpace: descriptionFormData.availableSpace,
          minAvailableSpace: descriptionFormData.minAvailableSpace,
          remainingLeaseTerm: descriptionFormData.remainingLeaseTerm,
          minSubLeaseTerm: descriptionFormData.minSubLeaseTerm,
          businessType: descriptionFormData.businessType,
          subBusinessType: descriptionFormData.subBusinessType,
          layout: descriptionFormData.layout,
          parking: descriptionFormData.parking,
          description: descriptionFormData.description,
        },
      });
      */
      setActiveMenu(PROVIDER_SIDEBAR_MENUS.IMAGES_VIDEOS);
      window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
    }
  };

  useEffect(() => {
    if (params?.type !== "new" && !temp) {
      if (!!Object.values(providerDetail).length) {
        setTemp(true);
        setDescriptionFormData({
          ...descriptionFormData,
          //price: providerDetail?.spaceFeedDetails?.price,
          rent: providerDetail?.spaceFeedDetails?.rent,
          totalSpace: providerDetail?.spaceFeedDetails?.totalSpace,
          //availableSpace: providerDetail?.spaceFeedDetails?.availableSpace,
          //minAvailableSpace:
          //  providerDetail?.spaceFeedDetails?.minAvailableSpace,
          remainingLeaseTerm:
            providerDetail?.spaceFeedDetails?.remainingLeaseTerm,
          //minSubLeaseTerm: providerDetail?.spaceFeedDetails?.minSubLeaseTerm,
          businessType: providerDetail?.spaceFeedDetails?.businessType,
          //subBusinessType: providerDetail?.spaceFeedDetails?.subBusinessType,
          //layout: providerDetail?.spaceFeedDetails?.layout,
          //parking: providerDetail?.spaceFeedDetails?.parking,
          description: providerDetail?.spaceFeedDetails?.description,
        });
      }
    }
  }, [loading]);

  useEffect(() => {
    const fetchBusinessList = async () => {
      try {
        const res = await api.get("/business-type");
        if (res?.data?.status === 200) {
          setBusinessList(res?.data?.response);
        }
      } catch (error) {
        toast.error("Error fetching business list");
      }
    };

    fetchBusinessList();
  }, []);

  return (
    <>
      <div className="col-md-9">
        <div className="m-5">
          <div className="card">
            <div className="card-header">
              <h5 className="bold">Property Details</h5>
            </div>
            <div className="card-body">
              
              <div className="row">
                {/*
                <div className="form-group col-md-4 col-sm-12">
                  
                  <label htmlFor="Price/SQFT">
                    Price/SQFT
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="price-tooltip"
                    ></i>
                    <Tooltip id="price-tooltip">Current Business’ Price/SQFT (Yearly)</Tooltip>
                  </label>
                  <input
                    name="price"
                    onChange={handleChange}
                    value={descriptionFormData.price}
                    type="number"
                    className="form-control"
                    id="Price/SQFT"
                    placeholder="Enter Price/SQFT"
                    ref={refs.price}
                  />
                  {errors.price && (
                    <div className="text-danger">{errors.price}</div>
                  )}
                  
                </div>
                  */}
                <div className="form-group col-md-5 col-sm-12">
                  <label htmlFor="rentfee">
                    Monthly Sublet Rent
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="rent-tooltip"
                    ></i>
                    <Tooltip id="rent-tooltip"> Sublet Rent (Monthly)</Tooltip>
                  </label>
                  <input
                    type="number"
                    name="rent"
                    onChange={handleChange}
                    value={descriptionFormData.rent}
                    className="form-control"
                    id="rentfee"
                    placeholder="Sublet Rent (Monthly)"
                    ref={refs.rent}
                  />
                  {errors.rent && (
                    <div className="text-danger">{errors.rent}</div>
                  )}
                </div>
              </div>
              
              <div className="row">
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="Available/SQFT">
                    Total SQFT
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="totalSpace-tooltip"
                    ></i>
                    <Tooltip id="totalSpace-tooltip"> Available SQFT (Current Business’ Available Sublet Space)</Tooltip>
                  </label>
                  <input
                    type="number"
                    name="totalSpace"
                    onChange={handleChange}
                    value={descriptionFormData.totalSpace}
                    className="form-control"
                    id="total/SQFT"
                    placeholder="Enter Available SQFT"
                    ref={refs.totalSpace}
                  />
                  {errors.totalSpace && (
                    <div className="text-danger">{errors.totalSpace}</div>
                  )}
                </div>
                  
                {/*
                <div className="form-group col-md-3 col-sm-12">
                  <label htmlFor="availableSqft">
                    Available SQFT
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="availableSpace-tooltip"
                    ></i>
                    <Tooltip id="availableSpace-tooltip"> Available SQFT (Sublease)</Tooltip>
                  </label>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <input
                      type="number"
                      name="minAvailableSpace"
                      value={descriptionFormData.minAvailableSpace}
                      onChange={handleChange}
                      className="form-control"
                      id="availableSqft"
                      placeholder="Min"
                    />
                    <input
                      type="number"
                      name="availableSpace"
                      style={{ marginLeft: "15px" }}
                      value={descriptionFormData.availableSpace}
                      onChange={handleChange}
                      className="form-control"
                      id="availableSqft"
                      placeholder="Max"
                      ref={refs.availableSpace}
                    />
                  </div>
                  {errors.availableSpace && (
                    <div className="text-danger">
                      {errors.availableSpace || errors.minAvailableSpace}
                    </div>
                  )}
                </div>
                */}
             </div>
              <div className="row">
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="leaseTerm">
                    Remaining Lease Term
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="remainingLeaseTerm-tooltip"
                    ></i>
                    <Tooltip id="remainingLeaseTerm-tooltip"> Current Business’ Remain Lease Term (Month)</Tooltip>
                  </label>
                  <input
                    type="number"
                    name="remainingLeaseTerm"
                    value={descriptionFormData.remainingLeaseTerm}
                    onChange={handleChange}
                    className="form-control"
                    id="leaseTerm"
                    placeholder="Enter Remaining Lease Term"
                    ref={refs.remainingLeaseTerm}
                  />
                  {errors.remainingLeaseTerm && (
                    <div className="text-danger">
                      {errors.remainingLeaseTerm}
                    </div>
                  )}
                </div>
                {/*
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="minimumLease">
                    Minimum Sub Lease Term
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="minSubLeaseTerm-tooltip"
                    ></i>
                    <Tooltip id="minSubLeaseTerm-tooltip">Minimum Sub Lease Term (Month)</Tooltip>
                  </label>
                  <input
                    type="number"
                    onChange={handleChange}
                    value={descriptionFormData.minSubLeaseTerm}
                    name="minSubLeaseTerm"
                    className="form-control"
                    id="minimumLease"
                    placeholder="Enter Minimum Sub Lease Term"
                    ref={refs.minSubLeaseTerm}
                  />
                  {errors.minSubLeaseTerm && (
                    <div className="text-danger">{errors.minSubLeaseTerm}</div>
                  )}
                </div>
                  */}
              </div>

              <div className="row">
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="businessType">
                    Business Type
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <i
                      className="fas fa-info-circle"
                      data-tooltip-id="businessType-tooltip"
                    ></i>
                    <Tooltip id="businessType-tooltip"> Current Business Type</Tooltip>
                  </label>
                  <input
                    type="text"
                    name="businessType"
                    value={descriptionFormData.businessType}
                    onChange={handleInputChange}
                    className="form-control"
                    id="businessType"
                    placeholder="Enter Business Type"
                    autoComplete="on"
                    ref={refs.businessType}
                    list="businessTypeList"
                  />
                  <datalist id="businessTypeList">
                    {businessList?.map((item) => (
                      <option key={item?.id} value={item?.name}>
                        {item?.name}
                      </option>
                    ))}
                  </datalist>
                </div>

                {errors.businessType && (
                  <div className="text-danger">{errors.businessType}</div>
                )}
                {/*
                <div className="form-group col-md-5 col-sm-12">
                  <label
                    htmlFor="desiredLeaseType"
                    className="single-line-label"
                    title="Desired sub-lease business type"
                  >
                    Desired Sub Lease Business Type
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <Tooltip id="subBusinessType-tooltip">Desired sub-lease business type</Tooltip>
                  </label>
                  <input
                    type="text"
                    name="subBusinessType"
                    value={descriptionFormData.subBusinessType}
                    onChange={handleInputChange}
                    className="form-control w-100"
                    id="desiredLeaseType"
                    placeholder="Enter Desired Sub Lease Business Type"
                    ref={refs.subBusinessType}
                  />
                </div>
                {errors.subBusinessType && (
                  <div className="text-danger">{errors.subBusinessType}</div>
                )}
                */}
              </div>
              {/*
              <div className="row">
                <div className="form-group col-md-4 col-sm-12">
                  <label htmlFor="Layout">
                    Layout
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <Tooltip id="layout-tooltip">Layout of the property</Tooltip>
                  </label>
                  <input
                    name="layout"
                    value={descriptionFormData.layout}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="Layout"
                    placeholder="Enter Layout Value"
                    ref={refs.layout}
                  />
                  {errors.layout && (
                    <div className="text-danger">{errors.layout}</div>
                  )}
                </div>
                <div className="form-group col-md-3 col-sm-12">
                  <label htmlFor="Parking">
                    Parking
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <Tooltip id="parking-tooltip">Parking availability</Tooltip>
                  </label>
                  <input
                    type="text"
                    onChange={handleChange}
                    value={descriptionFormData.parking}
                    name="parking"
                    className="form-control"
                    id="Parking"
                    placeholder="Enter Parking Value"
                    ref={refs.parking}
                  />
                  {errors.parking && (
                    <div className="text-danger">{errors.parking}</div>
                  )}
                </div>
              </div>
              */}
              <div className="row">
                <div className="form-group col-md-9 col-sm-12">
                  <label htmlFor="Description">
                    Description
                    <span className="text-danger" style={{ marginLeft: '5px' }}>*</span>
                    <Tooltip id="description-tooltip">Detailed description of the property</Tooltip>
                  </label>
                  <textarea
                    name="description"
                    maxLength={1000}
                    value={descriptionFormData.description}
                    onChange={handleChange}
                    placeholder=" Enter Description"
                    className="form-control"
                    rows={7}
                    ref={refs.description}
                  />
                  {errors.description && (
                    <div className="text-danger">{errors.description}</div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-end descriptionButton">
                <button
                  type="button"
                  className="primary-btn"
                  onClick={handleSubmit}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyDescriptionForm;
